<template>
  <div class="card rules-card">
    <div
      class="card-header rules-header d-flex align-items-center justify-content-between"
      @click="isOpen = !isOpen"
      role="button"
    >
      <div class="d-flex align-items-center gap-8">
        <img :src="helpSvg" alt="Ajuda" />
        <span class="rules-title">Como solicitar o Reembolso</span>
      </div>
      <img :src="isOpen ? arrowUp : arrowDown" alt="Mostrar/Esconder" />
    </div>

    <b-collapse :visible="isOpen">
      <div class="card-body rules-body px-4 pb-4 pt-2">
        <p class="rules-intro">
          Para garantir agilidade no seu pagamento, siga estes passos:
        </p>

        <div class="rules-content">
          <p>
            <strong>1. Documento de Comprovação:</strong>
          </p>
          <ul class="rules-sublist">
            <li>
              <strong>ACM:</strong> Solicite a
              <strong>declaração de associado</strong>
              diretamente à secretaria da ACM pelo WhatsApp
              <a class="rules-link" @click="redirectPage('acm-whatsapp')"
                >(48) 99193-4085</a
              >
              ou pelo e-mail
              <a class="rules-link" @click="redirectPage('acm-email')"
                >secretaria@acm.org.br</a
              >.
            </li>
            <li>
              <strong>CREMESC:</strong> Acesse o
              <a class="rules-link" @click="redirectPage('comprovacao')"
                >Portal de Serviços do CRM/SC</a
              >
              e emita a <strong>Certidão de Regularidade Financeira</strong>.
              Documentos como comprovantes de agendamento ou boletos não são
              aceitos.
            </li>
            <li>
              <strong>SIMESC:</strong> Solicite a
              <strong>declaração de filiação</strong>
              diretamente à administração do Sindicato, solicitação pode ser
              feita pelo WhatsApp
              <a class="rules-link" @click="redirectPage('simesc-whatsapp')"
                >(48) 99621-8614</a
              >, ou pelo e-mail
              <a class="rules-link" @click="redirectPage('simesc-email')"
                >simesc@simesc.org.br</a
              >. Conheça o SIMESC assistindo ao vídeo:
              <a class="rules-link" @click="redirectPage('simesc-video')"
                >https://youtu.be/hcf478Fw4g0</a
              >.
            </li>
          </ul>
          <p>
            <strong>2. Dados Bancários:</strong> O valor será creditado na
            <strong>conta de Pessoa Física</strong> cadastrada na Cooperativa.
            <a class="rules-link" @click="redirectPage('bancarios')"
              >Verifique ou atualize seus dados aqui.</a
            >
          </p>
          <p>
            <strong>3. Solicitação:</strong> Use o botão
            <strong>Anexar Comprovante</strong> para escolher o arquivo e
            finalize em <strong>Solicitar reembolso</strong>.
          </p>
          <p>
            <strong>4. Pesquisa de Satisfação:</strong> Para liberar o pagamento
            do reembolso, responda à
            <strong>Pesquisa de Satisfação e Saúde Cooperados 2026</strong>
            (disponível após o envio do comprovante). É o passo final para
            concluir sua solicitação.
          </p>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import arrowDown from "../../../assets/images/arrow_down.svg";
import arrowUp from "../../../assets/images/arrow_up.svg";
import helpSvg from "../../../assets/images/help.svg";

export default {
  name: "AnnuityRefundRules",
  data() {
    return {
      isOpen: false,
      arrowUp,
      arrowDown,
      helpSvg,
    };
  },
  methods: {
    redirectPage(value) {
      switch (value) {
        case "comprovacao":
          window.open("https://crmsc.org.br/certidoes/", "_blank");
          break;
        case "acm-whatsapp":
          window.open("https://wa.me/5548991934085", "_blank");
          break;
        case "acm-email":
          window.location.href = "mailto:secretaria@acm.org.br";
          break;
        case "simesc-whatsapp":
          window.open("https://wa.me/5548996218614", "_blank");
          break;
        case "simesc-email":
          window.location.href = "mailto:simesc@simesc.org.br";
          break;
        case "simesc-video":
          window.open("https://youtu.be/hcf478Fw4g0", "_blank");
          break;
        case "bancarios":
          this.$router.push({
            path: "/cadastro/meios-pagamento",
            query: { from: "annuity-refund-rules" },
          });
          break;
        default:
          this.$router.push({
            path: "/home",
          });
          break;
      }
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Trebuchet MS", sans-serif !important;
}

.gap-8 {
  gap: 8px;
}
.rules-card {
  border-radius: 12px;
  border: 1px solid var(--background-1);
  overflow: hidden;
}
.rules-header {
  background-color: var(--background-1);
  border: none;
  padding: 18px 24px;
  cursor: pointer;
  user-select: none;
}
.rules-header:hover {
  background-color: var(--background-5);
}
.rules-icon {
  color: var(--grey-13);
  font-size: 1.3rem;
}
.rules-title {
  color: var(--dark-2);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.2px;
}
.chevron-icon {
  color: var(--green-3);
  font-size: 0.8rem;
  transition: transform 0.25s ease;
}
.chevron-open {
  transform: rotate(180deg);
}
.rules-body {
  border-top: 1px solid var(--background-4);
}
.rules-intro {
  margin: 8px 16px;
  color: var(--grey-9);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
}
.rules-content {
  margin: 20px 16px;
  font-style: normal;
  line-height: 24px;
}
.rules-content a {
  cursor: pointer;
}
.rules-content p {
  margin-bottom: 20px;
  font-size: 16px;
  color: var(--dark-2);
}
.rules-link {
  color: var(--green-3);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.rules-sublist {
  list-style: disc;
  padding-left: 20px;
  margin: 0 0 20px 0;
}

.rules-sublist li {
  font-size: 16px;
  color: var(--dark-2);
  line-height: 24px;
  margin-bottom: 16px;
}

.rules-sublist li:last-child {
  margin-bottom: 0;
}
</style>
